<template>
  <el-dialog :title="dialogName" :class="[currentTheme]" :visible.sync="dialogVisible" class="no-header-dialog"  :close-on-click-modal="false" width="100%" :fullscreen="true" append-to-body>

    <div class="main-box archive-main">
      <!-- 左侧树结构 -->
      <div class="left-panel">
        <div class="tree-box">
          <div class="area-tree">
            <div class="tree-box">
              <div class="archive-title"  v-if="pageFrom != 'ProblemFollowupBlood' && pageFrom != 'ProblemFollowupGlucose'">

                <div class="title-info">
                  <span class="archive-name">{{archiveInfo.sickName}}</span>
                  <span class="archive-sex">{{archiveInfo.sickSex === '1'? '男' : '女'}}</span>
                  <span class="archive-age">{{archiveInfo.sickAge}}</span>
                </div>

                <el-card class="box-card title-card">
                  <div slot="header" class="clearfix">
                    <span>基本信息</span>
                  </div>
                  <div>
                    <div class="archive-single">本人电话：{{archiveInfo.sickPhone}}</div>
                    <div class="archive-single">管理团队：{{archiveInfo.manageTeamName}}</div>
                    <div class="archive-single">建档日期：{{archiveInfo.archiveTime}}</div>
                    <div class="archive-tag">
                      <el-tag type="error" class="el-tag el-tag--danger el-tag--mini el-tag--dark" v-if="archiveInfo.problemBloodFlag == '1'">高血压</el-tag>
                      <el-tag type="error" class="el-tag el-tag--danger el-tag--mini el-tag--dark" v-if="archiveInfo.problemGlucoseFlag == '1'">糖尿病</el-tag>
                    </div>
                  </div>
                </el-card>

              </div>
              <div class="archive-tree left">
                <ul id="treeDemo" class="ztree"></ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧内容 -->
      <div class="right-panel">
        <div class="archive-right-title">
          <div class="title-left" v-if="currentMenuName">{{currentMenuName}}</div>
          <div class="title-right">
            <div class="single-but-list">
              <div class="th-button" @click="addRecord()" :disabled="hasAddBtn"><i class="wk wk-add"></i><span>新增</span></div>
            </div>
            <div class="single-but-list">
              <div class="th-button" @click="copyLastData()" v-if="(pageType=='ProblemFollowupBlood' || pageType=='ProblemFollowupGlucose') && !isParent && operateType == 'add'"><i class="wk wk-preservation"></i><span>复制上一期</span></div>
            </div>
            <div class="single-but-list">
              <div class="th-button" @click="editRecord()" :disabled="isParent"><i class="wk wk-preservation"></i><span>保存</span></div>
            </div>
            <div class="single-but-list">
              <div class="th-button" @click="deleteInfo()"  v-if="(pageType=='ProblemFollowupBlood' || pageType=='ProblemFollowupGlucose') && !isParent && !!businessId"><i class="wk wk-discard"></i><span>删除</span></div>
            </div>
            <div class="single-but-list">
              <div class="th-button th-button-info" @click="back()"><i class="wk wk-back"></i><span>关闭</span></div>
            </div>
          </div>
        </div>
        <!-- 档案首页 -->
        <home-info ref="homeInfo" v-if="pageType === 'Archive'"></home-info>
        <!-- 体检 -->
        <medical-info ref="medicalInfo" v-if="pageType === 'Medical' && !isParent" @refreshTree="initDeptTree"></medical-info>

        <!-- 主动联系 -->
        <contact-add-or-edit ref="contactAddOrEdit" v-if="pageType === 'ArchiveContact' && !isParent" @refreshTree="initDeptTree"></contact-add-or-edit>

        <!-- 高血压随访 -->
        <blood-add-or-edit ref="bloodAddOrEdit" v-if="pageType === 'ProblemFollowupBlood' && !isParent" @refreshTree="initDeptTree"></blood-add-or-edit>

        <!-- 糖尿病随访 -->
        <glucose-add-or-edit ref="glucoseAddOrEdit" v-if="pageType === 'ProblemFollowupGlucose' && !isParent" @refreshTree="initDeptTree"></glucose-add-or-edit>
      </div>
    </div>
  </el-dialog>
</template>
<script>
  import HomeInfo from "./home/home-info.vue";
  import MedicalInfo from './medical/medical-info'
  import ContactAddOrEdit from './contact/contactEnter-add-or-edit'
  import BloodAddOrEdit from './blood/blood-add-or-edit'
  import GlucoseAddOrEdit from './glucose/glucose-add-or-edit'

  import {getToken} from "../../../utils/auth";


  import '../../../../static/js/jquery-3.7.1'
  import "../../../../plugins/zTree/js/jquery.ztree.core.min.js";
  import "../../../../plugins/zTree/js/jquery.ztree.excheck.min.js";

  export default {
    name: "projectAddOrEdit",
    data() {
      return {
        dialogVisible: false,
        dialogName: '健康档案',
        activeForm: '101',
        buttonsDisabled: true,
        layoutConfigure: {
          centerHeight: '100%'
        },
        pageFrom:'',
        currentMenuName: '',
        pageType: '',
        operateType: '',
        businessId: '',
        isParent:'',
        archiveInfo: {
          archiveId: '',                               //【基本信息】 主键ID
          sickName: '',                                //姓名
          sickSex: '',                                 //姓名
          sickAge: '',                                 //年龄
          manageTeamName:'',                           //管理团队名称
          orgCompleteName:'',
        },
        project_id: '',
        org_list: [],
        selected_id: '-1',
        setting: {
          data: {
            simpleData: {
              enable: true,
              idKey: "id",
              pIdKey: "pId",
              rootPId: -1
            }
          },
          view: {
            showIcon: false,
            showLine: true,        // 建议开启连线，方便调试
            dblClickExpand: true   // 确保双击能展开
          },
          edit: {
            drag: {
              // 打开复制功能，Ctrl+鼠标左键点击后拖拽
              isCopy: false,
              // 打开移动功能，鼠标左键点击后拖拽
              isMove: false
            },
            // 打开编辑
            enable: true,
            // 关闭删除
            showRemoveBtn: false,
            // 关闭修改名称
            showRenameBtn: false
          },
          // 异步配置（实现懒加载的关键）
          async: {
            enable: true, // 开启异步
            type: "post",
            url: process.env.BASE_URL + "/ph/archiveChildTreeData", // 你的后端接口地址
            autoParam: ["id=parentId"], // 自动传递参数：将当前节点的 id 作为 parentId 传给后端
            dataFilter: this.dataFilter, // 数据过滤钩子
            onAsyncSuccess: this.onAsyncSuccess, // 异步加载成功回调
            onAsyncError: this.onAsyncError,     // 异步加载失败回调
            beforeExpand: this.beforeExpand      // 展开前回调（可选，用于预加载）
          },
          callback: {
            // 树的点击事件
            onClick: this.zTreeOnClick,
            // 拖拽结束事件
            onDrop: this.zTreeOnDrop
          },
        },
        zNodes: [],
      }
    },
    components: {
      HomeInfo,
      MedicalInfo,
      ContactAddOrEdit,
      BloodAddOrEdit,
      GlucoseAddOrEdit
    },
    computed: {
      currentTheme() {
        return this.$store.getters.themeType; //获取当前的主题类型
      },
      //是否有新增按钮
      hasAddBtn(){
        if(this.pageType == 'ProblemFollowupBlood' || this.pageType == 'ProblemFollowupGlucose'
        || this.pageType == 'ArchiveContact'){

          return false;
        }
        return true;
      }
    },
    methods: {
      //初始化
      init(archiveId, type, pageFrom) {
        this.pageFrom = pageFrom || '';
         this.$forceUpdate();
        console.log("archiveId:"+archiveId+",pageFrom:===》" + this.pageFrom);
        this.dialogVisible = true;
        this.archiveInfo.archiveId = archiveId
        // 延迟调用，确保组件已经渲染完成
        this.$nextTick(() => {
          this.getArchiveInfo(archiveId);
          this.initDeptTree();
        });
      },
      //获取个人信息
      getArchiveInfo(archiveId){
        return this.request({
          method:'post',
          url:'/web/service?method=tPhPatientInfo_findById',
          params: {
            archiveId: archiveId
          }
        }).then((response) =>{          //这里使用了ES6的语法   //请求成功返回的数据
          //如果不为0，提示错误提示语
          if(response.code !== 0){
            this.$message.error(response.msg);
            return false;
          }

          if(!!response.data){
            this.archiveInfo = response.data;
          }


        })
      },
      //初始化部门树
      initDeptTree (){
         console.log("initDeptTree pageFrom:"+ this.pageFrom)
        let _self = this;
        return this.request({
          method:'post',
          url:'/web/service',
          params: {
            'method':'tPhArchiveHome_getTopTreeData',
            archiveId: this.archiveInfo.archiveId,
            pageFrom: this.pageFrom
          }
        }).then((response) =>{          //这里使用了ES6的语法   //请求成功返回的数据
          if (response.code === 0) {
            let list = response.rows;
            if(list == null || list == '' || list == undefined || list.length < 0){
              return false;
            }
            //循环遍历，根据部门级别显示图标
            for(let i = 0 ; i < list.length ; i ++){
              if(list[i].node_level == '1'){
                // list[i].icon = require('../../../../static/img/web.png');
              }else if(list[i].node_level == '3'){
                // list[i].icon = require('../../../../static/img/agent.png');
              }else if(list[i].node_level == '4'){
                // list[i].icon = require('../../../../static/img/business.png');
              }
            }

            this.zNodes = list;
            this.treeObj = $.fn.zTree.init($("#treeDemo"), this.setting, this.zNodes);
            let nodes = this.treeObj.getNodes();

            //如果是高血压和糖尿病随访，则默认展开，否则 默认收起所有节点
            if(this.pageFrom == 'ProblemFollowupBlood' || this.pageFrom == 'ProblemFollowupGlucose'){
              this.treeObj.expandAll(true);
            }else{
              this.treeObj.expandAll(false);
            }


            //选中第一个节点
            this.treeObj.selectNode(nodes[0], true);
            this.selected_id = nodes[0].id;

            console.log('++++++++刚开始加载+++++++++++++++++');
            console.log(nodes[0]);
            console.log('+++++++++++++++++++++++++');

            this.pageType = nodes[0].nodeType;
            this.isParent = nodes[0].isParent;

            // 只有当节点没有子节点时才触发事件
            if(!nodes[0].isParent) {
              //根据节点加载右侧的数据table
              this.$nextTick(() => {
                _self.getData(nodes[0]);
              })
            }
          }
        })
      },
      //树的点击事件
      zTreeOnClick: function(event, treeId, treeNode){
        if(treeNode.id != null && treeNode.id != '' && treeNode.id != undefined){
          this.selected_id = treeNode.id;

          setTimeout(() => {
            this.treeObj.expandNode(treeNode, true);
          }, 100);

          //根据节点加载右侧的数据table
          this.$nextTick(() => {
            this.getData(treeNode);
          })




        }
      },
      //拖拽结束事件
      zTreeOnDrop:function(event, treeId, treeNodes, targetNode, moveType){
        alert(treeNodes.length + "," + (targetNode ? (targetNode.tId + ", " + targetNode.name) : "isRoot" ));
      },
      freshArea:function(){
        $.fn.zTree.init($("#treeDemo"), this.setting, this.zNodes);
      },
      // 数据过滤器：在 zTree 渲染前处理数据
      dataFilter(treeId, parentNode, responseData) {
        // 可以在这里转换后端数据格式，确保符合 zTree 要求
        // 例如：如果后端返回的是 { code: 200, list: [...] }，需要返回 list
        return responseData.list || responseData;
      },
      // 异步加载成功回调
      onAsyncSuccess(event, treeId, treeNode, msg) {
        console.log("子节点加载成功", treeNode ? treeNode.name : "根节点");
        // 如果需要在加载完自动展开，可以在这里调用
        // if(treeNode) this.zTreeObj.expandNode(treeNode, true);
      },
      // 异步加载失败回调
      onAsyncError(event, treeId, treeNode, XMLHttpRequest, textStatus, errorThrown) {
        console.error("加载失败", treeNode ? treeNode.name : "根节点", errorThrown);
        alert("节点加载失败，请重试");
      },
      // 展开前回调（可选）
      beforeExpand(treeId, treeNode) {
        // 可以在这里做权限判断，返回 false 阻止展开
        return true;
      },
      back(){
        this.dialogVisible = false
        this.$emit('refreshData')
      },
      save(){

      },
      deleteInfo(){
        let pageType = this.pageType;
        let businessId = this.businessId;

        //高血压随访
        if(pageType == 'ProblemFollowupBlood'){
          this.delete('tPhDataChronicBloodFollow_delete', businessId);
        }else if(pageType == 'ProblemFollowupGlucose'){
          this.delete('tPhDataChronicGlucoseFollow_delete', businessId);
        }
      },
      delete(method, businessId){
        this.$confirm(`确定这条记录吗?`, '提示', {confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
          return this.request({
            method: 'post',
            url: '/web/service',
            params: {
              'method': method,
              'id': businessId
            }
          }).then((response) =>{
            if (response.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.initDeptTree();
                }
              })
            } else {
              this.$message.error(response.msg)
            }
          })
        }).catch(() => {})
      },

      //复制上一期数据
      copyLastData(){
        if(this.pageType == 'ProblemFollowupBlood'){
          this.$refs.bloodAddOrEdit.copyLastData();
        }else if(this.pageType == 'ProblemFollowupGlucose'){
          this.$refs.glucoseAddOrEdit.copyLastData();
        }
      },
      //添加一条记录
      addRecord(){
        if(this.pageType == 'ArchiveContact'){
          this.operateType = 'add';
          this.isParent = false
          this.$nextTick(()=>{
            this.$refs.contactAddOrEdit.resetTemp();
            this.$refs.contactAddOrEdit.init('save', '', this.archiveInfo);
          })
        }

        //高血压随访
        if(this.pageType == 'ProblemFollowupBlood'){
            this.operateType = 'add';
            this.isParent = false
            this.$nextTick(()=>{
              this.$refs.bloodAddOrEdit.resetTemp();
              this.$refs.bloodAddOrEdit.init('save', '', this.archiveInfo.archiveId);
            })
        }
        //糖尿病随访
        if(this.pageType == 'ProblemFollowupGlucose'){
            this.operateType = 'add';
            this.isParent = false
            this.$nextTick(()=>{
              this.$refs.glucoseAddOrEdit.resetTemp();
              this.$refs.glucoseAddOrEdit.init('save', '', this.archiveInfo.archiveId);
            })
        }
      },
      //保存一条记录
      editRecord(){
        //主动联系
        if(this.pageType == 'ArchiveContact'){
          this.$nextTick(()=>{
            this.$refs.contactAddOrEdit.save('dataForm');
          })
        }
        //高血压随访
        if(this.pageType == 'ProblemFollowupBlood'){
          this.$nextTick(()=>{
            this.$refs.bloodAddOrEdit.save('dataForm');
          })
        }
        //糖尿病随访
        if(this.pageType =='ProblemFollowupGlucose'){
          this.$nextTick(()=>{
            this.$refs.glucoseAddOrEdit.save('dataForm');
          })
        }
        //体检
        if(this.pageType =='Medical'){
          this.$nextTick(()=>{
            this.$refs.medicalInfo.save('dataForm');
          })
        }
      },
      getData(treeNode){

        let nodeType = treeNode.nodeType;
        let loadForm = treeNode.loadForm;

        this.pageType = nodeType;
        this.isParent = treeNode.isParent

        this.operateType = '';

        this.businessId = treeNode.code;
        let archiveId = this.archiveInfo.archiveId;

        if(treeNode.name) {
          // 去掉括号和括号中的内容
          this.currentMenuName = treeNode.name.replace(/\[.*?\]/g, '').trim();
        }

        console.log('++++++++++++++++++getData+++++++++++++++++++++++++++++++');
        console.log(treeNode);
        console.log(archiveId);
        console.log(nodeType);


        // 延迟调用，确保组件已经渲染完成
        if (nodeType === 'Archive') {                        //基本档案
          this.$nextTick(()=>{
            this.$refs.homeInfo.init(treeNode.code);
          })
        } else if (nodeType === 'Medical' && !!loadForm) {                //健康体检
          this.$nextTick(()=>{
            this.$refs.medicalInfo.init(treeNode.code);
          })
        } else if (nodeType === 'ArchiveContact' && !!loadForm) {                //健康体检
          this.$nextTick(()=>{
            this.$refs.contactAddOrEdit.resetTemp();
            this.$refs.contactAddOrEdit.init('edit', treeNode.code, this.archiveInfo);
          })
        }else if (nodeType === 'ProblemFollowupBlood' && !!loadForm) {                //高血压随访
          this.$nextTick(()=>{
            this.$refs.bloodAddOrEdit.resetTemp();
            this.$refs.bloodAddOrEdit.init('edit', treeNode.code, archiveId);
          })
        }
        else if (nodeType === 'ProblemFollowupGlucose' && !!loadForm) {                //糖尿病随访
          this.$nextTick(()=>{
            this.$refs.glucoseAddOrEdit.resetTemp();
            this.$refs.glucoseAddOrEdit.init('edit', treeNode.code, archiveId);
          })
        }

        //
        // else if (newActiveForm.startsWith("10401")) {       //慢病随访：高血压随访
        //   this.$refs.bloodInfo.init(this.archiveInfo.childMenuId);
        // }else if (val.startsWith("10402")) {       //慢病随访：糖尿病随访
        //   this.$refs.glucoseInfo.init(this.archiveInfo.childMenuId);
        // }



        // // 更新当前菜单名称
        // if(menuName) {
        //   // 去掉括号和括号中的内容
        //   this.currentMenuName = menuName.replace(/\[.*?\]/g, '').trim();
        // }
        //
        // let newActiveForm = ''
        // if(pId == 0){
        //   newActiveForm = val
        // }else{
        //   //子菜单 需要根据childMenuId进行查询
        //   newActiveForm = pId
        //   this.archiveInfo.childMenuId = val
        // }
        //
        // // 只有当activeForm发生变化时才进行切换
        // if(this.activeForm !== newActiveForm){
        //   this.activeForm = newActiveForm
        //
        //
        // }
      },

    }
  }
</script>

<style>
  @import '../../../../plugins/zTree/css/zTreeStyle/zTreeStyle.css';
</style>

<style scoped>

/deep/ .ztree li a.curSelectedNode{
  height: auto !important;
}

/deep/ .ztree *{font-size: 14px;}

/deep/ .ztree li span.button.center_open {
  background-position: -92px -14px;
}

/deep/ .ztree li span.button.center_close {
  background-position: -74px -14px;
}

 .no-header-dialog /deep/ .el-dialog__header{
  display: none !important;
}

.archive-main {
  display: flex;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 999;
  padding-top: 20px;
}

.archive-tree{
  padding: 0 20px;
}

.archive-title{margin: 10px;}
.archive-title .title-info{margin: 10px auto;}
.archive-title .title-info .archive-name{font-weight: bold; font-size: 16px;}
.archive-title .title-info .archive-sex{margin-left: 10px; font-size: 14px;}
.archive-title .title-info .archive-age{margin-left: 10px; font-size: 14px;}
.archive-title .title-card .archive-single{line-height: 25px;height: 25px}
.archive-title .title-card .archive-tag{margin-top: 5px;}




.left-panel {
  width: 300px;
  height: 100%;
  border-right: 1px solid #e4e7ed;
  overflow-y: auto;
}

.left-panel::-webkit-scrollbar {
  width: 6px;
}

.left-panel::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

.left-panel::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.right-panel {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.fullScreen-btn {
  padding: 10px;
  border-bottom: 1px solid #e4e7ed;
  overflow-x: auto;
  white-space: nowrap;
  width: 80%
}

.but-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

.menu-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.button-group {
  display: flex;
  gap: 10px;
}

.single-but-list {
  display: inline-block;
}

.th-button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.right-panel .xr-layout {
  flex: 1;
  overflow: auto;
}

  /deep/ .ztree li a.curSelectedNode {
    background-color: #1890ff !important; /* 背景色：改为你的主题色 */
    color: #fff !important;               /* 字体颜色 */
    border: none !important;              /* 去掉默认的边框 */
    opacity: 0.8;                         /* 可选：透明度 */
    font-weight: bold;                    /* 可选：加粗 */
  }

  /* --- 2. 悬停状态样式 (鼠标移入) --- */
  /deep/ li a:hover {
    background-color: #e6f7ff !important; /* 悬停背景色 */
    color: #1890ff !important;            /* 悬停字体颜色 */
    text-decoration: none;                /* 去掉下划线 */
  }

  /* --- 3. 节点文字基础样式 --- */
  /deep/ li a {
    height: 30px;                         /* 调整行高 */
    line-height: 30px;                    /* 垂直居中 */
    font-size: 14px;                      /* 字体大小 */
    padding: 0 5px;                       /* 内边距 */
  }

  .archive-right-title{width: 100%; height: 30px; padding: 0 20px;}
  .archive-right-title .title-left{float: left; line-height: 30px; color: rgb(0, 0, 0); font-family: SimHei, 黑体, sans-serif; font-weight: bold; font-size: 16px;}
  .archive-right-title .title-right{float: right; overflow: hidden;}


</style>



// WEBPACK FOOTER //
// src/views/ph/archive/archive-info.vue